var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "PortalWidget",
    {
      attrs: { widget: _vm.widget },
      scopedSlots: _vm._u([
        {
          key: "headerContent",
          fn: function() {
            return [
              _c("div", { staticClass: "header-extra" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.filters.name.value,
                      expression: "filters.name.value"
                    }
                  ],
                  staticClass:
                    "form-control input-md widget-header-input m-r-10",
                  attrs: {
                    type: "search",
                    placeholder: _vm.$t("SEARCH_USER_GROUPS")
                  },
                  domProps: { value: _vm.filters.name.value },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.filters.name, "value", $event.target.value)
                    }
                  }
                })
              ])
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      !_vm.loading
        ? _c("div", { staticClass: "m-b-15" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-success btn-sm",
                attrs: { type: "button", disabled: _vm.showAddNewForm },
                on: { click: _vm.displayNewForm }
              },
              [
                _c("i", { staticClass: "fa fa-plus" }),
                _vm._v(" "),
                _c("span", {
                  directives: [
                    {
                      name: "t",
                      rawName: "v-t",
                      value: "USER_GROUPS_ADD_BUTTON",
                      expression: "'USER_GROUPS_ADD_BUTTON'"
                    }
                  ]
                })
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-table",
        {
          staticClass: "table_beauty",
          attrs: {
            data: _vm.userGroups,
            "current-page": _vm.currentPage,
            "page-size": 20,
            "hide-sort-icons": true,
            filters: _vm.filters
          },
          on: {
            "update:currentPage": function($event) {
              _vm.currentPage = $event
            },
            "update:current-page": function($event) {
              _vm.currentPage = $event
            },
            totalPagesChanged: function($event) {
              _vm.totalPages = $event
            }
          },
          scopedSlots: _vm._u([
            {
              key: "body",
              fn: function({ displayData }) {
                return _c(
                  "tbody",
                  {},
                  [
                    _vm.showAddNewForm
                      ? _c(
                          "tr",
                          {
                            staticClass:
                              "row-inline-new-form slide-down bg-row-even"
                          },
                          [
                            _c(
                              "td",
                              { attrs: { colspan: "100" } },
                              [
                                !_vm.showAddNewInvites
                                  ? _c("UserGroupForm", {
                                      attrs: {
                                        "new-group": true,
                                        "show-loader":
                                          _vm.createGroupStatus.status ===
                                          "pending"
                                      },
                                      on: {
                                        cancel: _vm.hideNewForm,
                                        submit: _vm.onCreate
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.showAddNewInvites
                                  ? _c(
                                      "div",
                                      { staticClass: "p-l-15 p-r-15 p-t-15" },
                                      [
                                        _c(
                                          "legend",
                                          { staticClass: "f-s-13 p-b-10" },
                                          [
                                            _vm._v(
                                              "\n              Invite Users to "
                                            ),
                                            _c("strong", [
                                              _vm._v(_vm._s(_vm.newGroup.name))
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-xs btn-danger legend-right-button",
                                                attrs: { type: "button" },
                                                on: {
                                                  click:
                                                    _vm.closeNewGroupInvites
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "typcn typcn-delete"
                                                }),
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(
                                                      _vm.createdNewInviteForNewGroup
                                                        ? "Close"
                                                        : "Skip"
                                                    ) +
                                                    "\n              "
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("Invites", {
                                          attrs: {
                                            "invite-target-type": "managers",
                                            "invite-target-id": _vm.newGroup.id,
                                            "existing-users": _vm.getExistingUsersForRole(
                                              _vm.newGroup.type
                                            )
                                          },
                                          on: {
                                            "created-new-invite":
                                              _vm.inviteCreatedForNewGroup,
                                            "link-existing-user":
                                              _vm.linkExistingUser
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(displayData, function(row, index) {
                      return [
                        !(_vm.isMobile && _vm.activeActionId == row.id)
                          ? _c(
                              "tr",
                              {
                                key: row.id,
                                class: {
                                  "bg-row-odd": index % 2 === 0,
                                  "bg-row-even": index % 2 !== 0
                                }
                              },
                              [
                                _vm.isMobile
                                  ? _c("td", [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn btn-list-function btn-expand-actions",
                                          on: {
                                            click: function($event) {
                                              return _vm.displayMobileAction(
                                                row.id
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-ellipsis-v"
                                          })
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    staticClass: "clickable",
                                    on: {
                                      click: function($event) {
                                        return _vm.displayEditForm(row.id)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(row.name) +
                                        "\n          "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      row.type === "Affiliate"
                                        ? "Publisher"
                                        : row.type
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-center" }, [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        row.adminReportView ? "Yes" : "No"
                                      ) +
                                      "\n          "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-center" }, [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(row.readOnly ? "Yes" : "No") +
                                      "\n          "
                                  )
                                ]),
                                _vm._v(" "),
                                !_vm.isMobile
                                  ? _c(
                                      "td",
                                      [
                                        _c("UserGroupActions", {
                                          attrs: {
                                            group: row,
                                            disabled: _vm.formActive,
                                            "show-loader":
                                              _vm.updateGroupStatus.status ===
                                              "pending"
                                          },
                                          on: {
                                            "show-edit": _vm.displayEditForm,
                                            "show-invites": _vm.displayInvites,
                                            "confirm-delete-group":
                                              _vm.confirmDeleteUserGroup
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isMobile && _vm.activeActionId == row.id
                          ? _c(
                              "tr",
                              {
                                key: row.id + "-mobile",
                                staticClass:
                                  "mobile-actions ng-animate-disabled slide-right"
                              },
                              [
                                _c(
                                  "td",
                                  { attrs: { colspan: "10" } },
                                  [
                                    _c("UserGroupActions", {
                                      attrs: {
                                        group: row,
                                        disabled: _vm.formActive
                                      },
                                      on: {
                                        "collapse-actions": function($event) {
                                          !_vm.formActive &&
                                            _vm.hideMobileAction()
                                        },
                                        "show-edit": _vm.displayEditForm,
                                        "show-invites": _vm.displayInvites,
                                        "confirm-delete-group":
                                          _vm.confirmDeleteUserGroup
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showEditForm(row.id)
                          ? _c(
                              "tr",
                              {
                                key: row.id + "-edit",
                                staticClass: "slide-down bg-row-even"
                              },
                              [
                                _c(
                                  "td",
                                  { attrs: { colspan: "100" } },
                                  [
                                    _c("UserGroupForm", {
                                      attrs: {
                                        "new-group": false,
                                        "show-loader":
                                          _vm.updateGroupStatus.status ===
                                          "pending",
                                        group: row
                                      },
                                      on: {
                                        cancel: _vm.hideEditForm,
                                        submit: _vm.updateGroup
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showInviteForm(row.id)
                          ? _c(
                              "tr",
                              {
                                key: row.id + "-invites",
                                staticClass: "slide-down bg-row-even"
                              },
                              [
                                _c("td", { attrs: { colspan: "100" } }, [
                                  _c(
                                    "div",
                                    { staticClass: "p-l-15 p-r-15" },
                                    [
                                      _c(
                                        "legend",
                                        { staticClass: "f-s-13 p-b-10" },
                                        [
                                          _vm._v(
                                            "\n                Users\n                "
                                          ),
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-xs btn-danger legend-right-button",
                                              attrs: { type: "button" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.hideInvites(row.id)
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "typcn typcn-delete"
                                              }),
                                              _vm._v(
                                                "\n                  Close\n                "
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("Invites", {
                                        attrs: {
                                          "invite-target-type": "managers",
                                          "invite-target-id": row.id,
                                          "existing-users": _vm.getExistingUsersForRole(
                                            row.type
                                          )
                                        },
                                        on: {
                                          cancel: _vm.hideInvites,
                                          "delete-user": _vm.deleteUser,
                                          "link-existing-user":
                                            _vm.linkExistingUser
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ]
                            )
                          : _vm._e()
                      ]
                    })
                  ],
                  2
                )
              }
            }
          ])
        },
        [
          _c("thead", { attrs: { slot: "head" }, slot: "head" }, [
            _c(
              "tr",
              [
                _vm.isMobile ? _c("th") : _vm._e(),
                _vm._v(" "),
                _c("v-th", {
                  directives: [
                    {
                      name: "t",
                      rawName: "v-t",
                      value: "USER_GROUP_TABLE_COL_NAME",
                      expression: "'USER_GROUP_TABLE_COL_NAME'"
                    }
                  ],
                  attrs: { "sort-key": "name", "default-sort": "asc" }
                }),
                _vm._v(" "),
                _c("v-th", {
                  directives: [
                    {
                      name: "t",
                      rawName: "v-t",
                      value: "USER_GROUP_TABLE_COL_TYPE",
                      expression: "'USER_GROUP_TABLE_COL_TYPE'"
                    }
                  ],
                  attrs: { "sort-key": "type" }
                }),
                _vm._v(" "),
                _c("th", {
                  directives: [
                    {
                      name: "t",
                      rawName: "v-t",
                      value: "USER_GROUP_TABLE_COL_ADMIN_REPORT",
                      expression: "'USER_GROUP_TABLE_COL_ADMIN_REPORT'"
                    }
                  ],
                  staticClass: "text-center",
                  attrs: { "sort-key": "adminReportView" }
                }),
                _vm._v(" "),
                _c("th", {
                  directives: [
                    {
                      name: "t",
                      rawName: "v-t",
                      value: "USER_GROUP_TABLE_COL_READ_ONLY",
                      expression: "'USER_GROUP_TABLE_COL_READ_ONLY'"
                    }
                  ],
                  staticClass: "text-center",
                  attrs: { "sort-key": "readOnly" }
                }),
                _vm._v(" "),
                !_vm.isMobile
                  ? _c("th", {
                      directives: [
                        {
                          name: "t",
                          rawName: "v-t",
                          value: "TABLE_COL_ACTIONS",
                          expression: "'TABLE_COL_ACTIONS'"
                        }
                      ]
                    })
                  : _vm._e()
              ],
              1
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "pagination-min" }, [
        _c(
          "div",
          { staticClass: "text-center p-7" },
          [
            _c("smart-pagination", {
              attrs: {
                "current-page": _vm.currentPage,
                "total-pages": _vm.totalPages,
                "max-page-links": 10
              },
              on: {
                "update:currentPage": function($event) {
                  _vm.currentPage = $event
                },
                "update:current-page": function($event) {
                  _vm.currentPage = $event
                }
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.loading
        ? _c(
            "div",
            { staticClass: "text-center empty-records" },
            [
              _c("Loader"),
              _vm._v(" "),
              _c("span", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: "USER_GROUPS_TABLE_LOADING",
                    expression: "'USER_GROUPS_TABLE_LOADING'"
                  }
                ]
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.emptyUserGroups
        ? _c("div", {
            directives: [
              {
                name: "t",
                rawName: "v-t",
                value: "USER_GROUPS_TABLE_EMPTY",
                expression: "'USER_GROUPS_TABLE_EMPTY'"
              }
            ],
            staticClass: "well well-sm text-center"
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showModal
        ? _c(
            "ConfirmationModal",
            {
              attrs: {
                entity: _vm.userGroupToDelete,
                title: _vm.$t("DELETE_GROUP_MODAL_TITLE"),
                "cancel-button-text": _vm.$t("CANCEL"),
                "confirm-action-text": _vm.$t("DELETE"),
                "confirm-button-loading": _vm.deletingUserGroup
              },
              on: { confirm: _vm.deleteGroup, close: _vm.hideModal }
            },
            [
              _c("i18n", {
                attrs: {
                  path: "DELETE_GROUP_CONFIRMATION_MODAL_TEXT",
                  tag: "span"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "groupName",
                      fn: function() {
                        return [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.userGroupToDelete.name))
                          ])
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  false,
                  741607721
                )
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }